import { useBaseDataContext } from ".";

export default function useAddDelDataContext<AddPortfolioAccountParams, DelPortfolioAccountParams>({
    route,
    controller
}: {
    route: string
    controller: string
}){
    const {
        putBaseBooleanResult,
        deleteBaseBooleanResult,
    } = useBaseDataContext(route);

    const add = (params: AddPortfolioAccountParams) => putBaseBooleanResult({
        controller: controller,
        body: params
    });

    const del = (params: DelPortfolioAccountParams) => deleteBaseBooleanResult({
        controller: controller,
        params: params
    });
    return { 
        add,
        del
    }
}